module.exports = __webpack_public_path__ + "img/matomo-piwik.png";